<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header title="面接情報" />
      <div class="align-justify">
        <p class="margin-0">
          応募者に公開する「面接情報」を求人ごとに設定します。
        </p>
        <p class="boss-text margin-top-0">
          「面接情報」は企業様管理画面でのみ登録・編集が可能です。営業担当者・制作担当者側では編集できません。
        </p>
      </div>
      <!-- 公開設定 -->
      <div
        class="boss-joboffer-title boss-setting margin-top-2"
        data-test="interview-setting-title"
      >
        公開設定
      </div>
      <p
        class="boss-text margin-top-0 margin-bottom-1"
        data-test="interview-setting-description"
      >
        公開する面接情報を、求人ごとに設定できます。<br>
        掲載中、あるいは今後掲載予定の求人が、以下に表示されます。通常、掲載開始日の前日15時以降から設定可能です。
      </p>
      <interview-information-jobs
        :jobs="jobs"
        :interviews="interviewInformations"
        @update="updateJobInterviewTies"
      />

      <!-- 公開設定 ここまで -->

      <!-- 面接情報表示 -->
      <div
        class="boss-joboffer-title boss-setting margin-top-2"
        data-test="interview-information-title"
      >
        面接情報
      </div>
      <div class="grid-x align-justify">
        <div class="medium-10 cell">
          <p
            class="boss-text margin-top-0 margin-bottom-1"
            data-test="interview-information-description"
          >
            登録すると「公開設定」で選択肢に表示されます。以下の新規登録・編集・削除は、掲載状態に関わらず、いつでも可能です。
          </p>
        </div>
        <div class="medium-2 cell">
          <button
            class="float-right boss-button boss-button-new"
            data-test="register-button-information"
            @click="$router.push({ name: 'interviewInformationRegister' })"
          >
            <span class="boss-icon-new" />
            <span class="boss-button-new-text">新規登録する</span>
          </button>
        </div>
      </div>
      <div v-if="interviewInformations.length > 0">
        <interview-informations
          :interviews="interviewInformations"
          @fetch="fetch"
        />
      </div>
      <div
        v-else
        class="grid-x grid-margin-y align-center margin-top-2"
      >
        <span
          class="cell medium-4 subheader"
          data-test="no-infornmation-text"
        >面接情報が登録されていません。</span>
      </div>

      <!-- 面接情報表示 ここまで -->

      <!-- 面接場所表示 -->
      <div
        class="boss-joboffer-title boss-setting margin-top-2"
        data-test="interview-place-title"
      >
        面接場所
      </div>
      <div class="grid-x align-justify">
        <div class="medium-10 cell">
          <p
            class="boss-text margin-top-0 margin-bottom-1"
            data-test="interview-place-description"
          >
            登録すると「応募者管理」画面で、応募者へのメッセージやリマインドメールにご利用いただけます。
          </p>
        </div>
        <div class="medium-2 cell">
          <button
            class="float-right boss-button boss-button-new"
            data-test="register-button-place"
            @click="callMordalInner()"
          >
            <span class="boss-icon-new" />
            <span class="boss-button-new-text">新規登録する</span>
          </button>
        </div>
      </div>
      <div v-if="places.length > 0">
        <interview-places
          :places="places"
          @fetchPlaces="fetchPlaces"
          @editInterviewPlace="editInterviewPlace"
        />
      </div>
      <div
        v-else
        class="grid-x grid-margin-y align-center margin-top-2"
      >
        <span
          class="cell medium-4 subheader"
          data-test="no-place-text"
        >面接場所が登録されていません。</span>
      </div>
      <!-- ▼面接場所登録・更新モーダル -->
      <entry-interview-place-modal-inner
        ref="mordalInner"
        :interview-place="interviewPlace"
        @fetchPlaces="fetchPlaces"
        @resetInterviewPlace="resetInterviewPlace"
      />
      <!-- 面接場所表示 ここまで -->

    <!-- ▲Main Container -->
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import InterviewInformationJobs from '@/components/organisms/InterviewInformationJobs'
import EntryInterviewPlaceModalInner from '@/components/atoms/EntryInterviewPlaceModalInner.vue'
import InterviewInformations from '@/components/organisms/InterviewInformations.vue'
import InterviewPlaces from '@/components/organisms/InterviewPlaces.vue'

export default {
  components: {
    SettingHeader,
    InterviewInformationJobs,
    EntryInterviewPlaceModalInner,
    InterviewInformations,
    InterviewPlaces
  },
  data () {
    return {
      jobs: [],
      interviewInformations: [],
      places: [],
      interviewPlace: {}
    }
  },
  created () {
    this.fetch()
    this.fetchPlaces()
  },
  methods: {
    callMordalInner () {
      this.$refs.mordalInner.doAction()
    },
    editInterviewPlace (place) {
      this.$set(this, 'interviewPlace', place)
      this.callMordalInner()
    },
    fetchJobs () {
      this.$http.secured.get('/interview/jobs').then(response => {
        this.$set(this, 'jobs', response.data)
      })
    },
    fetchInterviews () {
      this.$http.secured.get('/interview/interviews').then(response => {
        this.$set(this, 'interviewInformations', response.data)
      })
    },
    fetchPlaces  () {
      this.$http.secured.get('/company/settings/entry/interview_place').then(response => {
        this.$set(this, 'places', response.data)
      })
    },
    updateJobInterviewTies (jobId, jobInterviewId) {
      this.$set(this.jobs[this.jobs.findIndex(job => job.jobId === jobId)], 'jobInterviewId', jobInterviewId)
      // 公開設定が変更されるため、最新の面接情報公開ステータスを取得する
      this.fetchInterviews()
    },
    fetch () {
      this.fetchJobs()
      this.fetchInterviews()
    },
    resetInterviewPlace () {
      this.$set(this, 'interviewPlace', {})
    }
  }
}
</script>
